import { Inject, Injectable } from 'angular-ts-decorators';
import { IProductFilterModuleConfiguration } from '../models/product-filter-module-configuration';

const baseUrl = '/public-api/product-filter-module';

@Injectable('productFilterModuleApiService')
export class ProductFilterModuleApiService {
  public static $inject = ['$http'];

  constructor(@Inject('$http') private $http: ng.IHttpService) { }

  public getConfiguration(id: string): ng.IPromise<IProductFilterModuleConfiguration> {
    return this.$http
      .get<IProductFilterModuleConfiguration>(`${baseUrl}/${id}`)
      .then((response: ng.IHttpResponse<IProductFilterModuleConfiguration>) => response.data);
  }
}
